import React from 'react';
import { UserCheck } from 'lucide-react';
import type { User } from '../../../../shared/types/index.js';

interface RoleScopingNoticeProps {
  user: User | null;
  onOpenProfileModal: () => void;
}

export const RoleScopingNotice: React.FC<RoleScopingNoticeProps> = ({
  user,
  onOpenProfileModal,
}) => {
  if (!user) return null;

  return (
    <div
      className={`p-4 rounded-2xl border flex items-center justify-between text-xs ${
        user.role === 'penulis'
          ? 'bg-sky-50/80 border-sky-200 text-sky-950'
          : user.role === 'penerbit'
          ? 'bg-purple-50/80 border-purple-200 text-purple-950'
          : 'bg-emerald-50/80 border-emerald-200 text-emerald-950'
      }`}
    >
      <div className="flex items-center gap-3">
        <span
          className={`px-2.5 py-1 rounded-lg font-bold uppercase tracking-wider text-[10px] ${
            user.role === 'penulis'
              ? 'bg-sky-200 text-sky-950'
              : user.role === 'penerbit'
              ? 'bg-purple-200 text-purple-950'
              : 'bg-emerald-200 text-emerald-950'
          }`}
        >
          Cakupan Data: {user.role}
        </span>
        <div>
          <p className="font-semibold text-sm">
            {user.role === 'penulis' && `Dasbor Pribadi Penulis: ${user.name}`}
            {user.role === 'penerbit' &&
              `Dasbor Penerbit: ${user.organization || user.name} (Kode: ${
                user.publisherCode || '8042'
              })`}
            {user.role === 'admin' && 'Dasbor Pengawasan Administrator UIBN Nasional'}
          </p>
          <p className="text-[11px] opacity-80 mt-0.5">
            {user.role === 'penulis' &&
              'Statistik dan riwayat pemindaian berikut dihitung khusus berdasarkan buku-buku yang Anda tulis.'}
            {user.role === 'penerbit' &&
              'Statistik dan riwayat pemindaian berikut dihitung khusus berdasarkan katalog buku terbitan Anda.'}
            {user.role === 'admin' &&
              'Statistik mencakup agregat seluruh penerbit, penulis, dan pembaca di tingkat nasional.'}
          </p>
        </div>
      </div>

      <button
        type="button"
        id="btn-dashboard-manage-profile"
        onClick={onOpenProfileModal}
        className="shrink-0 ml-4 px-3 py-1.5 rounded-xl bg-white hover:bg-slate-50 text-slate-800 font-semibold text-xs border border-slate-200/80 shadow-2xs transition flex items-center gap-1.5 cursor-pointer active:scale-95"
      >
        <UserCheck className="w-3.5 h-3.5 text-indigo-600" />
        <span className="hidden sm:inline">Kelola Profil Akun</span>
        <span className="sm:hidden">Profil</span>
      </button>
    </div>
  );
};
